import { Close, CloseFullscreen, Fullscreen } from "@mui/icons-material";
import { Button, DialogTitle, IconButton, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

interface MuiDialogHeaderProps {
    title: string;
    fullScreen?: boolean;
    setFullScreen?: () => void;
    onClose: () => void;
    showCloseText?: boolean;
    leftContent?: JSX.Element;
}

export default function MuiDialogHeader(props: MuiDialogHeaderProps) {
    const { title, fullScreen, setFullScreen, onClose, showCloseText, leftContent } = props;
    const theme = useTheme();
    const { t } = useTranslation();
    return (
        <DialogTitle>
            <div style={{ background: theme.palette.background.default, borderBottom: `1px solid ${theme.palette.divider}`, margin: '-16px -24px 0px -24px', height: '56px' }}>
                <div style={{ float: 'left', display: 'flex' }} >
                    <Typography variant='h1' fontWeight='bold' sx={{ marginLeft: '22px', color: 'text.primary' }} lineHeight={'56px'} fontSize={20}>{title} </Typography>
                    {leftContent}
                </div>
                <div style={{ float: 'right', display: 'flex', alignContent: 'flex-end' }}>

               
                        {setFullScreen && <IconButton onClick={() => {
                            setFullScreen();
                        }} >
                            {fullScreen ? <CloseFullscreen /> : <Fullscreen />}
                        </IconButton>}
                        {showCloseText && <Button sx={{ marginRight: '8px'}} onClick={() => {onClose()}}><div style={{display: 'flex'}}><Typography variant='h1' color='primary'  lineHeight={'42px'} fontSize={16}>{t('Users.Close')}</Typography><Close color='primary' sx={{ marginTop: '8px'}}/></div></Button>}
                        {!showCloseText && <Button sx={{ marginRight: '8px'}} onClick={() => {onClose()}}><div style={{display: 'flex'}}><Close color='primary' sx={{ marginTop: '8px'}}/></div></Button>}
                    
                </div>
            </div>
        </DialogTitle>
    )
}
